import { render, staticRenderFns } from "./file-history.vue?vue&type=template&id=04647b1c&scoped=true"
import script from "./file-history.vue?vue&type=script&lang=js"
export * from "./file-history.vue?vue&type=script&lang=js"
import style0 from "./file-history.vue?vue&type=style&index=0&id=04647b1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04647b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04647b1c')) {
      api.createRecord('04647b1c', component.options)
    } else {
      api.reload('04647b1c', component.options)
    }
    module.hot.accept("./file-history.vue?vue&type=template&id=04647b1c&scoped=true", function () {
      api.rerender('04647b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/components/file-history.vue"
export default component.exports